"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class SelectionGroup extends _react.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = { selection: undefined }, this.setSelection = selection => this.setState({ selection }), _temp;
  }

  render() {
    const { children } = this.props;

    return children({
      selection: this.state.selection,
      setSelection: this.setSelection
    });
  }
}
exports.default = SelectionGroup;
SelectionGroup.propTypes = {
  children: _propTypes2.default.func.isRequired
};